import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/components/LegalHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/components/news/CopyLinkButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/components/news/NewsMedia.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/.pnpm/next@14.2.16_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/.pnpm/next@14.2.16_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
